import { render } from "./ActionEmailOverview.vue?vue&type=template&id=2263af2c"
import script from "./ActionEmailOverview.vue?vue&type=script&lang=js"
export * from "./ActionEmailOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/ActionEmailOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2263af2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2263af2c', __exports__)) {
    api.reload('2263af2c', __exports__)
  }
  
  module.hot.accept("./ActionEmailOverview.vue?vue&type=template&id=2263af2c", () => {
    api.rerender('2263af2c', render)
  })

}


export default __exports__